<template>
  <div>
    <!-- eslint-disable vue/no-v-html -->
    <p
      :class="headlineClass"
      class="h3"
      :style="headlineStyle"
      v-html="headline"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
export default {
  name: 'HeadlineH3',
  props: {
    headline: {
      type: String,
      required: true,
    },
    headlineClass: {
      type: String,
      default: '',
    },
    headlineStyle: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
@import './headline-h3';
</style>
